
import { countElevator } from '@/api/elevator/elevatorApi.js'
import { searchElevatorCollectList } from '@/api/elevatorCollect/elevatorCollectApi.js'
import { yesterdayStatistics } from '@/api/fault/faultApi.js'
import { searchAgencyWorkOrderList } from '@/api/workOrder/wrokOderApi.js'
import { searchEnoentNoticeList } from '@/api/notice/noticeApi.js'

import { statistics } from '@/api/censusManageMent/faultCensusApi.js'
export default {
  name: 'index21',
  data() {
    return {
      // 收藏电梯参数
      ElevatorCollectFrom: {
        pageIndex: 1,
        pageSize: 10
      },
      ElevatorCollectList: [],
      // 代办工单列表所需参数
      AgencyWorkOrderFrom: {
        pageIndex: 1,
        pageSize: 10
      },
      followFrom: {
        pageIndex: 1,
        pageSize: 10,
        noticeType: 3
      },
      noticeFrom: {
        pageIndex: 1,
        pageSize: 10,
        noticeType: 1
      },
      AgencyWorkOrderList: [],
      followList: [],
      noticeList: [],
      spinFlag1: false,
      spinFlag2: false,
      spinFlag3: false,
      spinFlag4: false,
      // 各种状态数量对象
      countInfo: {},
      // 饼图配置
      optionPie: {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: 'pie'
        },
        credits: {
          enabled: false
        },
        title: {
          text: '昨日故障占比',
          align: 'left'
        },
        tooltip: {
          pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true
            },
            showInLegend: false
          }
        },
        series: [
          {
            name: '占比',
            colorByPoint: true,
            data: []
          }
        ]
      },
      optionIncivilization: {
        chart: {
          type: 'column'
        },
        title: {
          text: '前两月不文明行为占比',
          align: 'left'
        },
        xAxis: {
          categories: [],
          crosshair: true
        },
        yAxis: {
          min: 0,
          title: {
            text: ''
          }
        },
        tooltip: {
          borderColor: 'white',
          borderRadius: 10,
          formatter: function() {
            const arr = this.points
            let res = '<b>' + this.x + '</b><br/>'
            for (let i = 0; i < arr.length; i++) {
              if (arr[i].y !== 0) {
                res += arr[i].series.name + '&nbsp;&nbsp;&nbsp;&nbsp;' + arr[i].y + '次<br/>'
              }
            }
            if (arr.length === 0) {
              res += '无故障'
            }

            return res
          },
          shared: true,
          useHTML: true
        },
        credits: {
          enabled: false // 禁用版权信息
        },
        legend: {
          layout: 'vertical',
          align: 'right',
          verticalAlign: 'top',
          navigation: {
            activeColor: '#3E576F',
            animation: true,
            arrowSize: 12,
            inactiveColor: '#CCC',
            style: {
              fontWeight: 'bold',
              color: '#333',
              fontSize: '10px'
            }
          }
        },
        plotOptions: {
          series: {
            stacking: 'normal'
          }
          // column: {
          //   pointPadding: 0,
          //   borderWidth: 0,
          //   pointWidth: 24
          // }
        },
        series: []
      }

    }
  },
  destroyed() {

  },
  created() {
    // 获取各种状态数据
    countElevator().then(res => {
      this.countInfo = res.data.info
    })
    // 获取昨日故障
    yesterdayStatistics().then(res => {
      console.log('获取昨日故障', res)
      this.optionPie.series[0].data = res.data.info.series
    })
    // 获取不文明行为统计
    statistics({
      uncivilizedBehaviorFlag: 1,
      groupByElevator: 1,
      // 查前60天的不文明行为
      startTime: this.formatDate(-60) + '',
      endTime: this.formatDate(0) + ''
    }).then(res => {
      this.optionIncivilization.xAxis.categories = res.data.info.categories
      this.optionIncivilization.series = res.data.info.series
    })
    this.spinFlag1 = true
    this.spinFlag2 = true
    this.spinFlag3 = true
    this.spinFlag4 = true
    // 加载收藏电梯列表
    searchElevatorCollectList(this.ElevatorCollectFrom).then(res => {
      this.ElevatorCollectList = res.data.list
      this.spinFlag4 = false
    })
    // 加载代办工单
    searchAgencyWorkOrderList(this.AgencyWorkOrderFrom).then(res => {
      if (res.data.code === '0000') {
        this.AgencyWorkOrderList = res.data.info.list
        this.spinFlag1 = false
      }
    })
    // 加载提醒事项
    searchEnoentNoticeList(this.noticeFrom).then(res => {
      if (res.data.code === '0000') {
        this.noticeList = res.data.info.list
        this.spinFlag2 = false
      }
    })
    // 加载需关注电梯
    searchEnoentNoticeList(this.followFrom).then(res => {
      if (res.data.code === '0000') {
        this.followList = res.data.info.list
        this.spinFlag3 = false
      }
    })
  },
  methods: {
    actionWork(id) {
      this.$router.push({ name: 'Operation_2Page', query: { wrokId: id }})
    },
    actionElevatorCollect(id) {
      this.$router.push({ name: 'Monitor_2Page', query: { elevatorId: id }})
    },
    handleReachBottomAgencyWorkOrderList() {
      // 加载代办工单
      this.AgencyWorkOrderFrom.pageIndex = ++this.AgencyWorkOrderFrom.pageIndex
      searchAgencyWorkOrderList(this.AgencyWorkOrderFrom).then(res => {
        if (res.data.code === '0000') {
          if (res.data.info.list.length === 0) {
            this.AgencyWorkOrderFrom.pageIndex = --this.AgencyWorkOrderFrom.pageIndex
            return
          }
          for (let index = 0; index < res.data.info.list.length; index++) {
            this.AgencyWorkOrderList.push(res.data.info.list[index])
          }
        } else {
          this.AgencyWorkOrderFrom.pageIndex = --this.AgencyWorkOrderFrom.pageIndex
        }
      })
    },
    handleReachBottomNoticeList() {
      // 加载提醒事项
      this.noticeFrom.pageIndex = ++this.noticeFrom.pageIndex
      searchEnoentNoticeList(this.noticeFrom).then(res => {
        if (res.data.code === '0000') {
          if (res.data.info.list.length === 0) {
            this.noticeFrom.pageIndex = --this.noticeFrom.pageIndex
            return
          }
          for (let index = 0; index < res.data.info.list.length; index++) {
            this.noticeList.push(res.data.info.list[index])
          }
        } else {
          this.noticeFrom.pageIndex = --this.noticeFrom.pageIndex
        }
      })
    },
    handleReachBottomFollowList() {
      // 加载需关注电梯
      this.followFrom.pageIndex = ++this.followFrom.pageIndex
      searchEnoentNoticeList(this.followFrom).then(res => {
        if (res.data.code === '0000') {
          if (res.data.info.list.length === 0) {
            this.followFrom.pageIndex = --this.followFrom.pageIndex
            return
          }
          for (let index = 0; index < res.data.info.list.length; index++) {
            this.followList.push(res.data.info.list[index])
          }
        } else {
          this.followFrom.pageIndex = --this.followFrom.pageIndex
        }
      })
    },
    handleReachBottomElevatorCollectList() {
      // 加载收藏电梯
      this.ElevatorCollectFrom.pageIndex = ++this.AgencyWorkOrderFrom.pageIndex
      searchElevatorCollectList(this.ElevatorCollectFrom).then(res => {
        if (res.data.code === '0000') {
          if (res.data.info.list.length === 0) {
            this.ElevatorCollectFrom.pageIndex = --this.ElevatorCollectFrom.pageIndex
            return
          }
          for (let index = 0; index < res.data.info.list.length; index++) {
            this.ElevatorCollectList.push(res.data.info.list[index])
          }
        } else {
          this.ElevatorCollectFrom.pageIndex = --this.ElevatorCollectFrom.pageIndex
        }
      })
    },
    goToMap() {
      this.$router.push('/Monitor_5')
    }
  },
  props: {}
}
